import axiosInstance from 'services/axiosInstance';
import { IResponse } from 'services/types';
import { IUser } from 'services/user/types';

export const getUser = (id: number): IResponse<IUser> =>
  axiosInstance.request({
    url: `User/${id}`,
    method: 'GET',
  });
